// extracted by mini-css-extract-plugin
export var active = "_87-a";
export var activeIndicator = "_87-9";
export var disabled = "_87-b";
export var fullWidth = "_87-2";
export var lg = "_87-7";
export var md = "_87-6";
export var redoButtonTabGroup = "_87-0";
export var sm = "_87-5";
export var tabButton = "_87-4";
export var tabButtonsContainer = "_87-1";
export var themeDestructive = "_87-d";
export var themeNormal = "_87-c";
export var themeSuccess = "_87-e";
export var xl = "_87-8";
export var xs = "_87-3";